import React, {useState, useEffect} from "react";


export default function Services() {

  const locations = [['Neufahrn', 'Eching', 'Unterschleißheim'],
  ['Oberschleißheim', 'Garching', 'Ismaning'],
  ['Unterföhring', 'Kirchheim', 'Aschheim'],
  ['Feldkirchen', 'Poing', 'Vaterstetten'],
  ['Zorneding', 'Haar', 'Putzbrunn'],
  ['Deisenhofen', 'Neubiberg', 'Unterhaching'],
  ['Ottobrunn', 'Hohenbrunn', 'Oberhaching'],
  ['Höhenkirchen', 'Sauerlach', 'Starnberg'],
  ['Grünwald', 'Pullach', 'Gauting'],
  ['Neuried', 'Planegg', 'Gräfelfing'],
  ['Gilching', 'Germering', 'Fürstenfeldbruck'],
  ['Puchheim', 'Olching', 'Dachau'],
  ['Karlsfeld']
  ];

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    function handleWindowSizeChange() {
      setIsMobile(window.innerWidth < 768);
    }
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange();
    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  const columnCount = isMobile ? 2 : 3;

  return (
    <section id="locations" className="w-full bg-gray-100 py-8 text-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <h1 className="text-2xl md:text-3xl font-extrabold">Einsatzorte</h1>
          <h4 className="text-sm md:text-base font-semibold mt-4">Sie wohnen in der Nähe der folgenden Orte oder Gemeinden? Xhosha Baggerbetrieb kommt auch zu Ihnen!</h4>
        </div>
        <div className={`grid gap-4`} style={{ gridTemplateColumns: `repeat(${columnCount}, 1fr)` }}>
          {locations.map((subArray, index) => (
            <ul key={index} className="space-y-1">
              {subArray.map((location, idx) => (
                <li key={idx}>{location}</li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </section>
  );
}
